import { forgotPasswordVersion } from '../config'
import { isMobile, getElementHeight } from './base'

export function handleFreeShipping() {
    const { leftToFreeShipping } = getShoptetDataLayer('cartInfo')
    const isFreeShipping = leftToFreeShipping.priceLeft <= 0

    if (isFreeShipping) {
        $('.extra.delivery').addClass('shipping-is-free')
        $('.cart-free-shipping').addClass('shipping-is-free')
    }
}

export function contactBannerHTML() {
    return /* HTML */ `
        <div class="contact-banner">
            <h4>Kontaktieren Sie uns</h4>
            <div class="contact-wrapper">
                <a href="tel:+4915124171320" class="contact-banner__item">
                    <div class="contact-banner__icon tel"></div>
                    <div class="contact-banner__text">+49 151 2417 1320</div>
                </a>
                <a href="mailto:info@abamalwelt.de" class="contact-banner__item">
                    <div class="contact-banner__icon mail"></div>
                    <div class="contact-banner__text">info@abamalwelt.de</div>
                </a>
            </div>
        </div>
    `
}

function createAdvancedOrderProductTemplate(image, price, name, url, availability) {
    return /* HTML */ `
        <div class="advanced-order-product">
            ${url ? `<a href="${url}" class="advanced-order-image">` : '<div class="advanced-order-image">'}
            <img src="${image}" alt="${name}" />
            ${url ? '</a>' : '</div>'}
            <div class="advanced-order-name">
                ${url ? `<a href="${url}">` : ''}
                <div>
                <div class="advanced-order-name__text">${name}</div>
                <div class="advanced-order-availability">${availability}</div>
                </div>
                ${url ? '</a>' : ''}
                <div class="advanced-order-price">${price}</div>
            </div>
        </div>
    `
}
export function createAdvancedOrderProduct(options) {
    const handleAdvancedOrderLoaded = () => {
        const { image, price, url, availability } = options
        const name = $(".h2[data-testid='textPopupProductName']").text()

        const advancedOrderProductHtml = createAdvancedOrderProductTemplate(image, price, name, url, availability)

        $('.advanced-order-product').remove()
        $(advancedOrderProductHtml).insertAfter('.advanced-order .h1')
    }

    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', handleAdvancedOrderLoaded, { once: true })
}

function addScrollPadding() {
    const offset = 20
    const headerHeight =
        getElementHeight('.top-navigation-bar') +
        getElementHeight('.header-top') +
        getElementHeight('.header-bottom') +
        getElementHeight('.site-msg.information')

    document.documentElement.style.setProperty('--scroll-padding', `${headerHeight + offset}px`)
}

function emptyCart() {
    setTimeout(() => {
        const cart = getShoptetDataLayer('cart')
        const btn = `<a href="/" class = "btn btn-primary">Zurück zum Shop</a>`
        const title = `<h2 class="h1 cart-heading" data-testid="cartTitle">Ihr Warenkorb ist leer</h2>`
        const subtitle = `<p class="cart-subtitle">Ihr Warenkorb wartet auf die ersten Produkte – entdecken Sie jetzt unser Sortiment!</p>`
        const cartWidgetInner = $('.cart-widget-inner')
        const cartContent = $('.col-md-8 .cart-content')

        if (!cart.length) {
            $('body').addClass('cart-is-empty')
            cartContent.append($('.cart-heading'), subtitle, btn)
            if (isMobile()) {
                // mobile
                $('.cart-widget').addClass('cart-is-empty')
                cartWidgetInner.append(title, subtitle, btn)
            }
        } else {
            $('.cart-widget').removeClass('cart-is-empty')
        }

        $('#content-wrapper .cart-wrapper').addClass('ready')
    }, 200)
}

function addContactBanner() {
    // id--8 = registrace
    // id--7 = zapomenuté heslo

    const currentPageClass = ['type-manufacturers-listing', 'id-404', 'id--8', 'id--7']
    const currentPage = currentPageClass.find((className) => $(`.${className}`).length > 0)

    if (currentPage) {
        $('.sidebar').addClass('contact-banner-included')
        $('.sidebar').prepend(contactBannerHTML())
    }
}

function addPageType2Class() {
    // id--8 = registrace
    // id--7 = zapomenuté heslo

    const currentPageClass = ['type-manufacturers-listing', 'id--8']
    const currentPage = currentPageClass.find((className) => $(`.${className}`).length > 0)

    if (forgotPasswordVersion === 2) {
        if ($('.id--7').length) {
            $('body').addClass('able-custom-page-2')
        }

        return
    }

    // For other pages, keep existing logic
    if (currentPage) {
        $('body').addClass('able-custom-page-2')
    }
}

export function contactFormTemplate({ productForm = false, telInput = false }) {
    const productId = getShoptetDataLayer('product').id
    const productName = getShoptetDataLayer('product').name

    return /* HTML */ `
        <form
            action=${productForm ? '/action/MailForm/sendProductQuestion/' : '/action/MailForm/SendEmail/'}
            method="post"
            id=${productForm ? 'formProductQuestion' : 'formContact'}
            class="contact-form-able">
            <h2>Schreiben Sie uns</h2>
            <fieldset ${telInput ? 'class="wrap-elements"' : ''}>
                ${productForm ? `<input type="hidden" name="productId" value=${productId}>` : ''}
                <input type="hidden" name="formId" value=${productForm ? '10' : '1'} />

                <div class="form-group js-validated-element-wrapper">
                    <label for="fullName"><span class="required-asterisk">Vorname und Nachname </span></label>
                    <input
                        type="text"
                        value=""
                        name="fullName"
                        id="fullName"
                        class="form-control"
                        required="" />
                    <span class="no-display">Dieses Feld nicht ausfüllen</span>
                    <input type="text" name="surname" value="" class="no-display" />
                </div>
                ${telInput
                    ? /* HTML */ `
                          <div class="form-group js-validated-element-wrapper half-width">
                              <label for="phone">Telefon</label>
                              <input type="text" value="" name="phone" id="phone" class="form-control" />
                          </div>

                          <div class="form-group js-validated-element-wrapper half-width">
                              <label for="email">
                                  <span class="required-asterisk">E-mail</span>
                              </label>
                              <input
                                  type="email"
                                  value=""
                                  name="email"
                                  id="email"
                                  class="form-control"
                                  required="" />
                          </div>
                      `
                    : /* HTML */ `
                          <div class="form-group js-validated-element-wrapper">
                              <label for="email">
                                  <span class="required-asterisk">Email</span>
                              </label>
                              <input
                                  type="email"
                                  value=""
                                  name="email"
                                  id="email"
                                  class="form-control"
                                  required="" />
                          </div>
                      `}

                <div class="form-group js-validated-element-wrapper">
                    <label for="message">
                        <span class="required-asterisk">Zpráva</span>
                    </label>
                    <textarea name="message" rows="7" class="form-control" required="">
${productForm ? `Ich interessiere mich für das Produkt ${productName}. Bitte kontaktieren Sie mich.` : ''}
                    </textarea
                    >
                </div>

                <div class="form-group js-validated-element-wrapper consents consents-first">
                    <input
                        type="hidden"
                        name="consents[]"
                        id="consents40"
                        value="40"
                        data-special-message="validatorConsent" />
                    <label for="consents40" class="whole-width">
                       Mit dem Absenden der Nachricht erklären Sie sich mit
                        <a href="/podminky-ochrany-osobnich-udaju/" rel="noopener noreferrer">
                            den Datenschutzbestimmungen einverstanden.
                        </a>
                    </label>
                </div>

                <div class="form-group submit-wrapper">
                    <input type="submit" value="Senden" class="btn btn-primary" />
                </div>
            </fieldset>
        </form>
    `
}

export function createReviewsCarousel() {

    const swiper = new Swiper('.swiper-reviews', {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3
            }
        },
    });
}

export function initGlobalFunctions() {
    addContactBanner()
    setTimeout(addScrollPadding, 500)
    addPageType2Class()
    emptyCart()
    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        emptyCart()
    })
}
